import {makeStyles} from "@mui/styles";
import React from "react";

const useStyles = makeStyles(
  () => ({
    buildingName: {
      color: "#a80d1f",
      fontSize: "12px",
      fontWeight: "bold",
    },
    marker: {
      background: "#a80d1f",
      borderRadius: "50%",
      height: "7.5px",
      width: "7.5px",
    },
  }),
  {
    name: "Marker",
  }
);

export const Marker: React.FC<{
  lat: number;
  lng: number;
  text: string;
}> = ({text}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.buildingName}>{text}</div>
      <div className={classes.marker} />
    </div>
  );
};
